import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/cssbuy-spreadsheet-ultimate-guide/page";
import ArticleComparison from "@/pages/article/cssbuy-vs-kakobuy-comparison/page";
import ArticleShipping from "@/pages/article/cssbuy-shipping-guide/page";
import ArticleSellerDirectory from "@/pages/article/cssbuy-seller-directory/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/cssbuy-spreadsheet-ultimate-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/article/cssbuy-vs-kakobuy-comparison",
    element: <ArticleComparison />,
  },
  {
    path: "/article/cssbuy-shipping-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/article/cssbuy-seller-directory",
    element: <ArticleSellerDirectory />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;